/**
 * Observe DOM updates for Gravity Forms confirmation in modal
 * and focus the message when it appears.
 */

(() => {
    function focusGfConfirmation() {
        const modal = document.querySelector('.modal.show');

        if (!modal) {
            return;
        }

        const confirmation = modal.querySelector('.gform_confirmation_message');

        if (!confirmation) {
            return;
        }

        confirmation.setAttribute('tabindex', '-1');

        setTimeout(() => {
            confirmation.focus();
        }, 100);
    }

    const config = {
        attributes: false,
        childList: true,
        subtree: true,
    };

    const observer = new MutationObserver(focusGfConfirmation);

    observer.observe(document.body, config);
})();
